import React, { useState, useEffect } from 'react';

import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Login from './components/Login';
import Dashboard from './components/Dashboard';
import User from './components/User';
import FinesPageNoSidebar from './components/FinesPageNoSidebar'; // import your new page

import EventManager from './components/EventManager'; // import your new page

import CollectedFinesPage from './components/CollectedFinesPage'; // import your new page


import AppSettingPage from "./components/AppSettingMainPage";



import FinesPage from './components/FinesPage';


import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="vh-100 d-flex justify-content-center align-items-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (

    <Router>
  <Routes>
    {/* Redirect user after login based on role */}
    <Route
      path="/login"
      element={
        user ? (
          user.email === "admin@admin.com" ? (
            <Navigate to="/dashboard" />
          ) : (
            <Navigate to="/fineUserOverView" />
          )
        ) : (
          <Login />
        )
      }
    />

    {user?.email === "admin@admin.com" ? (
      <>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/fineUserOverView" element={<FinesPageNoSidebar />} />
        <Route path="/user" element={<User />} />
        <Route path="/fines" element={<FinesPage />} />
        
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="*" element={<Navigate to="/dashboard" />} />
        <Route path="/events" element={<EventManager />} />
        <Route path="/CollectedFinesPage" element={<CollectedFinesPage />} />


        <Route path="/app-settings" element={<AppSettingPage />} />

      </>
    ) : user ? (
      <>
        <Route path="/fineUserOverView" element={<FinesPageNoSidebar />} />
        <Route path="/" element={<Navigate to="/fineUserOverView" />} />
        <Route path="*" element={<Navigate to="/fineUserOverView" />} />
        {/* <Route path="/events" element={<EventManager />} /> */}

      </>
    ) : (
      <Route path="*" element={<Navigate to="/login" />} />
    )}
  </Routes>
</Router>

//   <Router>
//   <Routes>
//     <Route path="/login" element={user ? <Navigate to="/fineUserOverView" /> : <Login />} />

//     {user?.email === "admin@admin.com" ? (
//       <>
//         <Route path="/fineUserOverView" element={<FinesPageNoSidebar />} />
//         <Route path="/" element={<Navigate to="/Dashboard" />} />
//         <Route path="/user" element={<User />} />
//         <Route path="/fines" element={<FinesPage />} />
//         <Route path="*" element={<Navigate to="/fineUserOverView" />} />
//       </>
//     ) : user?.email === "fineuser@user.com" ? (
//       <>
//         <Route path="/fineUserOverView" element={<FinesPageNoSidebar />} />
//         <Route path="*" element={<Navigate to="/fineUserOverView" />} />
//       </>
//     ) : (
//       <Route path="*" element={<Navigate to="/login" />} />
//     )}
//   </Routes>
// </Router>



  // <Router>
  //   <Routes>
  //     <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />

  //     {user?.email === "admin@admin.com" ? (
  //       <>
  //         <Route path="/" element={<Dashboard />} />
  //         <Route path="/user" element={<User />} />
  //         <Route path="/fines" element={<FinesPage />} />
  //         {/* <Route path="/fines-no-sidebar" element={<FinesPageNoSidebar />} /> */}
  //         <Route path="*" element={<Navigate to="/" />} />
  //       </>
  //     ) : user ? (
  //       <>
  //         <Route path="/fineUserOverView" element={<FinesPageNoSidebar />} />
  //         <Route path="*" element={<Navigate to="/fines-no-sidebar" />} />
  //       </>
  //     ) : (
  //       <Route path="*" element={<Navigate to="/login" />} />
  //     )}
  //   </Routes>
  // </Router>


    // <Router>
    //   <Routes>
    //     <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
    //     <Route path="/" element={user ? <Dashboard /> : <Navigate to="/login" />} />
    //     <Route path="/user" element={user ? <User /> : <Navigate to="/login" />} />
       
    //       <Route path="/fines-no-sidebar" element={<FinesPageNoSidebar />} />
    //         <Route path="/fines" element={<FinesPage />} />

    //     <Route path="*" element={<Navigate to={user ? "/" : "/login"} />} />
    //   </Routes>
    // </Router>
  );
}



export default App;
